import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faDownload, faTrash } from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components';
import {
  Alert,
  AlertTitle, Button,
  Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
  ImageList,
  ImageListItem, ListItemIcon, ListItemText, Menu, MenuItem,
  Paper,
} from '@mui/material';
import { useFiles } from './hook';
import File from './file';
import EditorControls from '../BaseEditor/editorControls';
import Loader from '../../components/MaterialUI/loader';

export const StyledFileInput = styled.input.attrs({
  type: 'file',
  multiple: true,
})`
  display: none;
`;
export const StyledFileLabel = styled.label`
  display: inline;
  cursor: pointer;
  padding: 6px 8px;
  color: rgba(0, 0, 0, 0.87);
  font-size: 0.875rem;
  min-width: 64px;
  box-sizing: border-box;
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 500;
  line-height: 1.75;
  border-radius: 4px;
  letter-spacing: 0.02857em;
  text-transform: uppercase;
  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
`;

function Files({
  model,
  objectId,
}) {
  const {
    files,
    err,
    loading,
    onDragOver,
    onDrop,
    onFileInputChange,
    menuOpened,
    onCloseMenu,
    activeRef,
    onOpenMenu,
    onMenuItemsClick,
    descModalOpened,
    currentDescription,
    onCloseDescModal,
    onChangeDescription,
    onSaveDescription,
    deleteModalOpened,
    onCloseDeleteModal,
    onDeleteFile,
  } = useFiles({
    model,
    objectId,
  });
  return (
    <Paper
      onDragOver={onDragOver}
      onDrop={onDrop}
    >
      {loading && (
      <Loader text="Завантаження" />
      )}
      {err && (
        <Alert severity="error">
          {err}
        </Alert>
      )}
      <ImageList
        cols={4}
      >
        {files.map((file) => (
          <ImageListItem key={file.id}>
            <File
              url={file.data}
              mimeType={file.mimetype}
              description={file.description}
              onOpenMenu={onOpenMenu}
            />
          </ImageListItem>
        ))}
      </ImageList>
      <Alert severity="info">
        <AlertTitle>Додавання файлів</AlertTitle>
        Для того, щоб додати файли - перетяніть іх сюди, або натисніть кнопку:
        <StyledFileLabel>
          Завантажити файл
          <StyledFileInput onChange={onFileInputChange} />
        </StyledFileLabel>
      </Alert>
      <Menu
        open={menuOpened}
        onClose={onCloseMenu}
        anchorEl={activeRef}
      >
        <MenuItem onClick={onMenuItemsClick.onDescChange}>
          <ListItemIcon>
            <FontAwesomeIcon icon={faEdit} size="xs" />
          </ListItemIcon>
          <ListItemText>Змінити опис</ListItemText>
        </MenuItem>
        <MenuItem onClick={onMenuItemsClick.onDownload}>
          <ListItemIcon>
            <FontAwesomeIcon icon={faDownload} size="xs" />
          </ListItemIcon>
          <ListItemText>Скачати</ListItemText>
        </MenuItem>
        <MenuItem onClick={onMenuItemsClick.onDelete}>
          <ListItemIcon>
            <FontAwesomeIcon icon={faTrash} size="xs" color="red" />
          </ListItemIcon>
          <ListItemText>Видалити</ListItemText>
        </MenuItem>
      </Menu>
      <Dialog open={descModalOpened} onClose={onCloseDescModal} maxWidth="lg" fullWidth>
        <DialogTitle>Редагування опису</DialogTitle>
        <DialogContent>
          <EditorControls.StringInput
            label="опис"
            value={currentDescription}
            onChange={onChangeDescription}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onCloseDescModal}>Відміна</Button>
          <Button onClick={onSaveDescription}>Зберегти</Button>
        </DialogActions>
      </Dialog>
      <Dialog open={deleteModalOpened} onClose={onCloseDeleteModal} maxWidth="lg" fullWidth>
        <DialogTitle>Видалення файлу</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Ви дійсно бажаєте видалити цей файл?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onCloseDeleteModal}>Відміна</Button>
          <Button onClick={onDeleteFile}>Видалити</Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
}

Files.propTypes = {
  model: PropTypes.string.isRequired,
  objectId: PropTypes.number.isRequired,
};

export default Files;
